import type { ColumnsType } from 'antd/lib/table';
import type { Moment } from 'moment';
import React from 'react';
import type { Fetcher } from 'swr';

import axiosWithAuth from '@/lib/axios';

import ShowImage from './components/ShowImage';
import type { LockerHistory, LockerHistoryOptions } from './types';
import { lockerHistoryOptionsSchema, lockerHistorySchema } from './types';

export const optionsFetcher: Fetcher<LockerHistoryOptions> = async (
  url: string
) => {
  const res = await axiosWithAuth.get(url);
  const result = lockerHistoryOptionsSchema.safeParse(res.data);
  if (!result.success) {
    throw new Error(result.error.message);
  }
  return result.data;
};

export const historyFetcher: Fetcher<LockerHistory> = async (url: string) => {
  const res = await axiosWithAuth.get(url);
  const result = lockerHistorySchema.safeParse(res.data);
  if (!result.success) {
    throw new Error(result.error.message);
  }
  return result.data;
};

export const getHistoryUrl = ({
  selectedLocker,
  selectedEvent,
  queryTimes: queryTime,
  currentPage,
  sortTime,
}: {
  selectedLocker?: string | null;
  selectedEvent?: string | null;
  queryTimes?: [Moment, Moment] | null;
  currentPage: number;
  sortTime: 'ascend' | 'descend';
}) => {
  let historyUrl = '/ezcon/api/ultraLocker/backstageHistories?pageSize=10&';
  if (selectedLocker) {
    historyUrl += `lockerId=${selectedLocker}&`;
  }
  if (selectedEvent) {
    historyUrl += `event=${selectedEvent}&`;
  }
  if (queryTime) {
    const pattern = 'YYYY-MM-DD';
    const start = queryTime[0].format(pattern);
    const end = queryTime[1].format(pattern);
    historyUrl += `queryTimes=${start}&queryTimes=${end}&`;
  }
  historyUrl += `page=${currentPage}&`;
  historyUrl += `sortTime=${sortTime}`;
  return historyUrl;
};

export const getColumns = ({
  sortTime,
  setSortTime,
}: {
  sortTime: 'ascend' | 'descend';
  setSortTime: React.Dispatch<React.SetStateAction<'ascend' | 'descend'>>;
}) => {
  const columns: ColumnsType<LockerHistory['data'][number]> = [
    {
      title: '櫃位',
      dataIndex: 'lockerName',
    },
    {
      title: '類型',
      dataIndex: 'lockerType',
    },
    {
      title: '事件',
      dataIndex: 'eventName',
    },
    {
      title: '事件時間',
      dataIndex: 'eventTime',
      sorter: (a, b) => {
        return a.eventTime.localeCompare(b.eventTime);
      },
      sortOrder: sortTime,
      onHeaderCell: () => ({
        onClick: () =>
          setSortTime(sortTime === 'ascend' ? 'descend' : 'ascend'),
      }),
    },
    {
      title: '收件戶號',
      dataIndex: 'receiverHouseNumber',
    },
    {
      title: '影像',
      dataIndex: 'image',
      render(image: string) {
        if (!image) {
          return null;
        }
        return <ShowImage image={image} />;
      },
    },
  ];
  return columns;
};
